import { matchRange } from "../../model/commandeListSearch";

export function HighlightSearchText({ value, query }) {
    const text = String(value ?? "");
    const range = matchRange(text, query);
    if (!range) return text;
    return (
        <>
            {text.slice(0, range.start)}
            <mark className="commande-search-highlight">{text.slice(range.start, range.end)}</mark>
            {text.slice(range.end)}
        </>
    );
}

export function StarButton({ active, onClick }) {
    return (
        <button
            onClick={onClick}
            title={active ? "Retirer des favoris" : "Ajouter aux favoris"}
            style={{
                background: "none", border: "none", cursor: "pointer",
                padding: "5px", borderRadius: "4px",
                color: active ? "#f59e0b" : "#cbd5e1",
                fontSize: "20px", lineHeight: 1,
                display: "flex", alignItems: "center", justifyContent: "center",
                transition: "color 0.1s",
            }}
            onMouseEnter={e => { if (!active) e.currentTarget.style.color = "#fbbf24"; }}
            onMouseLeave={e => { if (!active) e.currentTarget.style.color = "#cbd5e1"; }}
        >
            {active ? "★" : "☆"}
        </button>
    );
}

// Correspondances de recherche cachées (patient, produit…) : deux visibles, les suivantes résumées.
export function SearchMatchesButton({ searchMatches, searchQuery, onClick }) {
    const visibleSearchMatches = searchMatches.slice(0, 2);
    if (visibleSearchMatches.length === 0) return null;
    const searchMatchDescription = searchMatches.map(match => `${match.type} ${match.value}`).join(", ");
    const hiddenCount = searchMatches.length - visibleSearchMatches.length;

    return (
        <button
            type="button"
            className="commande-search-context"
            title={searchMatches.map(match => `${match.type} : ${match.value}`).join("\n")}
            aria-label={`Correspondance de recherche : ${searchMatchDescription}`}
            onClick={onClick}
        >
            <span className="commande-search-context-label" aria-hidden="true">⌕ Correspondance</span>
            {visibleSearchMatches.map((match, matchIndex) => (
                <span className="commande-search-match" title={`${match.type} : ${match.value}`} key={`${match.type}-${match.value}`}>
                    <small>{match.type}</small>
                    <span><HighlightSearchText value={match.value} query={searchQuery} /></span>
                    {matchIndex === visibleSearchMatches.length - 1 && hiddenCount > 0 && (
                        <strong>+{hiddenCount}</strong>
                    )}
                </span>
            ))}
        </button>
    );
}
